<app-post :post-id="id"></app-post>
<div class="widget-wrapper">
    <!-- <app-widget-latest-video></app-widget-latest-video> -->
    <div class="sticky sticky_top">
        <app-widget-latest-posts :detect-current="true"></app-widget-latest-posts>
        <app-widget-social></app-widget-social>
    </div>
</div>
